(function() {
  if (customElements.get('product-showcase')) return;

  class ProductShowcase extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.autoPlayInterval = null;
      this.isMobile = false;
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      const sectionId = this.dataset.sectionId;
      this.container = this.querySelector('.ai-product-showcase-container-' + sectionId);
      this.items = Array.from(this.querySelectorAll('.ai-product-showcase-item-' + sectionId));

      if (!this.container || !this.items.length) return;

      window.addEventListener('resize', this.handleResize);
      this.initShowcase();
    }

    disconnectedCallback() {
      this.stopAutoPlay();
      window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 749;

      if (wasMobile !== this.isMobile) {
        this.stopAutoPlay();
        this.currentIndex = 0;
        this.initShowcase();
      }
    }

    initShowcase() {
      this.isMobile = window.innerWidth <= 749;

      if (this.isMobile) {
        this.setupMobileFadeSlider();
      } else {
        this.setupDesktopGrid();
      }
    }

    setupMobileFadeSlider() {
      this.items.forEach((item, index) => {
        item.classList.toggle('is-active', index === 0);
      });

      this.currentIndex = 0;

      if (this.items.length <= 1) return;

      this.startAutoPlay();
    }

    setupDesktopGrid() {
      this.items.forEach((item) => {
        item.classList.remove('is-active');
      });
    }

    startAutoPlay() {
      this.stopAutoPlay();

      this.autoPlayInterval = setInterval(() => {
        this.items[this.currentIndex].classList.remove('is-active');
        this.currentIndex = (this.currentIndex + 1) % this.items.length;
        this.items[this.currentIndex].classList.add('is-active');
      }, 3000);
    }

    stopAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
        this.autoPlayInterval = null;
      }
    }
  }

  customElements.define('product-showcase', ProductShowcase);
})();